module.exports = __webpack_public_path__ + "static/img/sd.99913644.jpg";